/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ISocialLinkContainerData } from './social-link-container.data';
import { ISocialLinkContainerProps } from './social-link-container.props.autogenerated';

export interface ISocialLinkContainerViewProps extends ISocialLinkContainerProps<ISocialLinkContainerData> {}

/**
 *
 * SocialLinkContainer component
 * @extends {React.PureComponent<ISocialLinkContainerProps<ISocialLinkContainerData>>}
 */
class SocialLinkContainer extends React.PureComponent<ISocialLinkContainerProps<ISocialLinkContainerData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default SocialLinkContainer;
